import { render } from "./WorkbookMain.vue?vue&type=template&id=e2204812&scoped=true&lang=true"
import script from "./WorkbookMain.vue?vue&type=script&lang=js"
export * from "./WorkbookMain.vue?vue&type=script&lang=js"

import "./WorkbookMain.vue?vue&type=style&index=0&id=e2204812&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2204812"

export default script